import { Box, Heading } from '@chakra-ui/layout';

type PageTitleProps = {
  title: string;
};

function PageTitle({ title }: PageTitleProps) {
  return (
    <Box
      width="min-content"
      borderBottom="2px solid"
      borderColor="teal.150"
      pb="0.5rem"
      mb="2rem"
    >
      <Heading as="h1" size="md" fontWeight="normal">
        {title}
      </Heading>
    </Box>
  );
}

export { PageTitle };
